module.exports = __webpack_public_path__ + "static/media/Sobes.48510a9e.md";